<script lang="ts" setup>
withDefaults(defineProps<{ status?: string, placeholder?: string, size?: string }>(), { placeholder: 'What are you looking for?', size: 'xl' })

const query = defineModel<string>('query')
</script>

<template>
  <div class="max-w-4xl mx-auto flex px-3 lg:px-6 relative">
    <div class=" bg-white rounded-3xl w-full flex-1 flex gap-1 flex-wrap">
      <UInput v-model="query" :placeholder="placeholder" class="w-full lg:flex-1" name="searchQuery"
        :loading="status === 'pending'" :size="size" icon="ri:search-line"
        :ui="{ icon: { trailing: { pointer: '' } }, base: '!ring-slate-200 !ring-2 hover:!ring-primary-800 focus:!ring-primary inline-flex items-center  !ring-offset-2 focus:!ring-offset-2 !ring-inset' }">
        <template #trailing>
          <UButton v-show="query !== ''" icon="ri:close-line" aria-label="Clear Search" color="gray" variant="ghost"
            size="xs" class="z-40 relative hover:text-red-500" @click="query = ''" />
        </template>
      </UInput>
      <SearchLocation :size="size" :status="status" class="flex mx-auto w-full lg:flex-1" />

      <slot />
    </div>
  </div>
</template>
